export const SUMMARY_TYPES = [
  { id: 'text_inspection_rating', name: 'text_inspection_rating' },
  { id: 'text_observation_area', name: 'text_observation_area' },
  { id: 'text_incident_occurence', name: 'text_incident_occurence' },
];

export const CHART_SETTING = {
  mobile: {
    ri1: 55,
    ro1: 80,
    ri2: 80,
    ro2: 90,
    width: 262,
    height: 262,
  },
  desktop: {
    ri1: 65,
    ro1: 90,
    ri2: 90,
    ro2: 100,
    width: 272,
    height: 272,
  },
};
